import React from 'react';
import IconButton from '@alltrails/shared/denali/components/IconButton';
import Location from '@alltrails/shared/icons/Location';
import ZoomIn from '@alltrails/shared/icons/ZoomIn';
import ZoomOut from '@alltrails/shared/icons/ZoomOut';
import RotateLeft from '@alltrails/shared/icons/RotateLeft';
import RotateRight from '@alltrails/shared/icons/RotateRight';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { wrapEventHandler } from '../../../utils/handlers';

type ZoomControlsProps = {
  handleZoomInClick: () => void;
  handleZoomOutClick: () => void;
  handleCurrLocClick: () => void;
  handleUndoClick?: () => void;
  handleRedoClick?: () => void;
};

const ZoomControls = ({ handleZoomInClick, handleZoomOutClick, handleCurrLocClick, handleUndoClick, handleRedoClick }: ZoomControlsProps) => (
  <div className={styles.container}>
    {handleUndoClick ? (
      <IconButton
        icon={{ Component: RotateLeft }}
        onClick={wrapEventHandler(handleUndoClick)}
        testId={StringConstantsMixin.strings.TRACK_DETAIL.UNDO}
        title={StringConstantsMixin.strings.TRACK_DETAIL.UNDO}
        variant="elevated"
        size="sm"
      />
    ) : null}
    {handleRedoClick ? (
      <IconButton
        icon={{ Component: RotateRight }}
        onClick={wrapEventHandler(handleRedoClick)}
        testId={StringConstantsMixin.strings.TRACK_DETAIL.REDO}
        title={StringConstantsMixin.strings.TRACK_DETAIL.REDO}
        variant="elevated"
        size="sm"
      />
    ) : null}
    <IconButton
      icon={{ Component: ZoomIn }}
      onClick={wrapEventHandler(handleZoomInClick)}
      testId={StringConstantsMixin.strings.SEARCH.ZOOM_IN}
      title={StringConstantsMixin.strings.SEARCH.ZOOM_IN}
      variant="elevated"
      size="sm"
    />
    <IconButton
      icon={{ Component: ZoomOut }}
      onClick={wrapEventHandler(handleZoomOutClick)}
      testId={StringConstantsMixin.strings.SEARCH.ZOOM_OUT}
      title={StringConstantsMixin.strings.SEARCH.ZOOM_OUT}
      variant="elevated"
      size="sm"
    />
    <IconButton
      icon={{ Component: Location }}
      onClick={wrapEventHandler(handleCurrLocClick)}
      testId={StringConstantsMixin.strings.SEARCH.CURRENT_LOCATION}
      title={StringConstantsMixin.strings.SEARCH.CURRENT_LOCATION}
      variant="elevated"
      size="sm"
    />
  </div>
);

export default ZoomControls;
